import {useEffect, useState} from "react";
import {FormProps} from "../../components/form/interface/formInterface";

import DivStyle from "../../components/style/div.component";

import {useSetRecoilState} from "recoil";
import {loadingState} from "../../recoil/loading.atom";
import SmallForm from "../../components/form/small_form";
import GAMEAPI from "../../api/game";

const GameCoupon = () => {
  const [couponType, setCouponType] = useState<null | any>({id: 1, name: "공용 쿠폰"});
  const setIsLoading = useSetRecoilState(loadingState);

  const [couponCode, setCouponCode] = useState("");
  const [tag, setTag] = useState("");
  const [type, setType] = useState("");
  const [expiredAt, setExpiredAt] = useState("");
  const [point, setPoint] = useState(0);
  const [reBuyInTicket, setReBuyInTicket] = useState(0);
  const [couponCount, setCouponCount] = useState(0);
  const [couponCodeLength, setCouponCodeLength] = useState(0);
  const [couponList, setCouponList] = useState<string[]>([]);
  const typeList = [
    {
      id: 1,
      name: "공용 쿠폰",
    },
    {
      id: 2,
      name: "개별 쿠폰",
    },
  ];

  const publicFormData : FormProps = {
    title: '공용 쿠폰 생성',
    form: [
      {
        value: couponType,
        setValue: setCouponType,
        options: typeList,
        label: "쿠폰 종류",
        width: "100%",
        type: "category",
      },
      {
        value: couponCode,
        setValue: setCouponCode,
        label: "쿠폰 코드",
        width: "100%",
        type: "input",
      },
      {
        value: tag,
        setValue: setTag,
        label: "쿠폰 메모",
        width: "100%",
        type: "input",
      },
      {
        value: type,
        setValue: setType,
        label: "쿠폰 타입 (빈값=중복사용가능, 같은 타입끼리 중복사용 불가)",
        width: "100%",
        type: "input",
      },
      {
        value: expiredAt,
        setValue: setExpiredAt,
        label: "쿠폰 만료일",
        width: "100%",
        type: "date",
      },
      {
        value: point,
        setValue: setPoint,
        label: "포인트",
        width: "100%",
        type: "input",
      },
      {
        value: reBuyInTicket,
        setValue: setReBuyInTicket,
        label: "리바인 티켓",
        width: "100%",
        type: "input",
      }

    ]
  }

  const privateFormData: FormProps = {
    title: '개별 쿠폰 생성',
    form: [
      {
        value: couponType,
        setValue: setCouponType,
        options: typeList,
        label: "쿠폰 종류",
        width: "100%",
        type: "category",
      },
      {
        value: couponCount,
        setValue: setCouponCount,
        label: "쿠폰 수량",
        width: "100%",
        type: "input",
      },
      {
        value: couponCodeLength,
        setValue: setCouponCodeLength,
        label: "쿠폰 코드 길이",
        width: "100%",
        type: "input",
      },
      {
        value: tag,
        setValue: setTag,
        label: "쿠폰 메모",
        width: "100%",
        type: "input",
      },
      {
        value: type,
        setValue: setType,
        label: "쿠폰 타입",
        width: "100%",
        type: "input",
      },
      {
        value: expiredAt,
        setValue: setExpiredAt,
        label: "쿠폰 만료일",
        width: "100%",
        type: "date",
      },
      {
        value: point,
        setValue: setPoint,
        label: "포인트",
        width: "100%",
        type: "input",
      },
      {
        value: reBuyInTicket,
        setValue: setReBuyInTicket,
        label: "리바인 티켓",
        width: "100%",
        type: "input",
      },

    ]
  }

  const add = async () => {


    if(window.confirm(`신규 쿠폰을 발행하시겠습니까?`)){
      setIsLoading(true);
      const body = {
        code: couponCode,
        codeCount: Number(couponCount),
        isCommon: couponType.id === 1,
        rewardList: {
          rebuyinTicket: Number(reBuyInTicket),
          point: Number(point),
        },
        tag: tag,
        couponType: type,
        endedAt: expiredAt,
        couponLength: Number(couponCodeLength)
      }
      const res = await GAMEAPI.generateCoupon(body);
      if(res.data.result === 1) {
        alert("신규 쿠폰이 발행되었습니다.");
        setCouponList(res.data.payload);
      }else{
        alert("쿠폰 발행에 실패하였습니다."+JSON.stringify(res.data) );
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setCouponCode("");
    setCouponCount(0);
    setCouponCodeLength(0);
    setTag("");
    setType("");
    setExpiredAt("");
    setPoint(0);
    setReBuyInTicket(0);
  }, [couponType]);

  return (
    <DivStyle
      style={{overflow: "auto"}}
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="row"
      marginTop="65px"
      setMobile={true}
    >

      <DivStyle
        width="50%"
        display="flex"
        flex_direction="column"
        align_items="center"
        height="800px"
        setMobileForm={true}
      >
        <h2 style={{color: "white", width: "auto", marginTop: "40px"}}>폼</h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <SmallForm
            form={couponType.id === 1 ? publicFormData.form : privateFormData.form}
            title={couponType.id === 1 ? publicFormData.title : privateFormData.title}
            add={add}
            save={()=>{}}
            mode={"I"}
          />
        </DivStyle>
      </DivStyle>
      <DivStyle
        width="50%"
        height="800px"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileForm={true}
      >
        <h2 style={{color: "white", width: "auto", marginTop: "40px"}}>결과</h2>
        <DivStyle
          width="95%"
          height="100%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <textarea style={{
            width: '100%',
            padding: '10px',
            height: '100%',
            backgroundColor: "#1E1E1E",
            color: "white",
          }} readOnly={true} value={couponList.length > 0 ? couponList.join("\n") : "쿠폰 코드가 발급되지 않았습니다."}/>
        </DivStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default GameCoupon;
